import React from 'react'
import Anchor from '../../ui/anchor'
import {createList, slugify} from '../../../utils/utilFunctions'
import {CategroiesWrap} from './categories.style'

const Categories = ({categories, ...restProps}) => {
    
    return(
        <CategroiesWrap {...restProps}>
            {categories.map(cat => (
                    <Anchor path={`/category/${cat.node.slug}`} key={cat.node.slug}>
                    {cat.node.name}
                </Anchor>
            ))}
        </CategroiesWrap>
    )
}

export default Categories;